import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import LazyLoad from 'vanilla-lazyload';

const isServer = typeof window === 'undefined';

// Only initialize lazyload one time for the entire application
if (!isServer && !document.lazyLoadInstance) {
  document.lazyLoadInstance = new LazyLoad({
    elements_selector: '.lazy', // CSS selector of the elements to load lazily
    load_delay: 1, // Time (in ms) each img needs to stay inside the viewport before its loading begins
  });
}

export class LazyImage extends React.Component {
  // Update lazyLoad after first rendering of every image
  componentDidMount() {
    document.lazyLoadInstance.update();
  }

  // Update lazyLoad after rerendering of every image
  componentDidUpdate() {
    document.lazyLoadInstance.update();
  }

  // Render the image with data-src
  renderImg(classes) {
    const { alt, src } = this.props;
    return <img alt={alt} className={classes}
      data-src={src} />;
  }

  // Render the background image with data-bg
  renderBackgroundImg(classes) {
    return <div className={classes} data-bg={`url(${this.props.backgroundImageSrc})`} />;
  }

  // Render the picture element with data-srcset for the source element
  renderPictureElement(classes) {
    const { alt, mobileImgSrc, src } = this.props;
    return (
      <picture>
        <source data-srcset={mobileImgSrc} media="(max-width: 767px)" />
        <img alt={alt} className={classes}
          data-src={src} />
      </picture>
    );
  }

  render() {
    const { classnames, imageType } = this.props;
    const classes = classNames({
      'lazy': true,
      [classnames]: !!classnames,
    });

    switch (imageType) {
      case 'background':
        return this.renderBackgroundImg(classes);
      case 'picture':
        return this.renderPictureElement(classes);
      default:
        return this.renderImg(classes);
    }
  }
}

LazyImage.propTypes = {
  alt: PropTypes.string,
  backgroundImageSrc: PropTypes.string,
  classnames: PropTypes.string,
  imageType: PropTypes.string,
  src: PropTypes.string,
};

LazyImage.defaultProps = {
  alt: '',
  backgroundImageSrc: '',
  classnames: '',
  imageType: '',
  src: '',
};

export default LazyImage;
